import React from 'react'
import Navbar from './Components/NavBar/NavBar'
import './CSS/NavBar/NavBar.css'
function App() {
  return (
    <>
     
      <Navbar />
    </>
  )
}

export default App
